export default __webpack_public_path__ + "static/media/Succes.07480b5c.png";